<script setup>
import AppTableConfirm from "@/components/table/AppTableConfirm.vue"
// import UserService from "@/services/UserService";
// import { getSchoolStaff } from "@/services/ApiUrlService";
import { useAppStore } from "@/stores/appStore"
import ScrollToTop from "@core/components/ScrollToTop.vue"
import initCore from "@core/initCore"
import { initConfigStore, useConfigStore } from "@core/stores/config"
import { hexToRgb } from "@layouts/utils"
import { langTypes } from "@/utils/constant"
import { useGettext } from "vue3-gettext"
import { useTheme } from "vuetify"
import { useAuthStore } from "./stores/authStore"
import { useBrevoChat } from "@/composables/useBrevoChat"
const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const loaded = ref(false)
const language = useGettext()
const route = useRoute()
const configStore = useConfigStore()
const appStore = useAppStore()
const authStore = useAuthStore()
const confirm = ref(null)
watch(confirm, (value) => {
  if (!value) return
  appStore.confirm = confirm
})
// const isLoggedIn = computed(
//   () => !!(authStore.accessToken && authStore.user && authStore.schoolStaffId)
// )
// ping
/*
setTimeout(async () => {
  if(!authStore.accessToken) return
  const response = await UserService.ping()
  appStore.newEntities = response.newEntities
}, 1000)
*/

watch(
  () => route.query,
  async (query) => {
    loaded.value = false
    const { uemail, utoken, lang } = query
    if (uemail && utoken) {
      const response = await $api("/auth", {
        method: "POST",
        body: {
          email: uemail,
          token: utoken,
        },
        loading: true,
        noPushMessage: true,
      })
      if (response && response.token) {
        authStore.login(response, route)
      }
    }
    if (lang) {
      const locale = langTypes.find((x) => x.name === lang)
      if (locale) {
        language.current = locale.id
        appStore.lang = locale.id
        useCookie("lang").value = locale.id
      }
    } else {
      if (!useCookie("lang").value) {
        useCookie("lang").value = "fr_FR"
        language.current = "fr_FR"
      }
    }

    setTimeout(() => {
      loaded.value = true
    }, 1200)
  },
  {
    immediate: true,
  }
)
if (import.meta.env.VITE_BREVO_CHAT_ID) {
  useBrevoChat()
}
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp
      :style="`--v-global-theme-primary: ${hexToRgb(
        global.current.value.colors.primary
      )}`"
    >
      <RouterView />

      <ScrollToTop />
    </VApp>
    <!-- <MessageSnackBar /> -->
    <AppTableConfirm ref="confirm" />
    <div
      v-if="!loaded"
      class="fixed top-0 left-0 w-100 h-100 d-flex justify-center align-center"
      style="z-index: 99; background-color: #fff"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </VLocaleProvider>
</template>
